import React from 'react';
import PropTypes from 'prop-types';
import './PlaylistCallTodo.styl';
import CallDetails from 'records/CallDetails';
import CoachingTodo from 'records/CoachingTodo';
import CoachingParticipant from 'records/CoachingParticipant';

export default class PlaylistCallTodo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.otherTodoText = this.otherTodoText.bind(this);
  }

  otherTodoText(score, comment) {
    const {
      otherParticipant: {info: otherInfo},
    } = this.props;
    const prompt = score && comment ? 'score and comment' : score ? 'score' : 'comment';
    return (
      <div className="other-todos">
        ({otherInfo.firstName} still needs to {prompt})
      </div>
    );
  }

  render() {
    const {
      call,
      todo,
      otherTodo,
      participant: {prepShouldComment, prepShouldScore},
    } = this.props;
    const todoClass = callIds => (callIds.includes(call.id) ? 'incomplete' : 'complete');

    const scoreClass = todoClass(todo.callsToScore);
    const commentClass = todoClass(todo.callsToComment);
    const otherNeedsScore = otherTodo.callsToScore.includes(call.id);
    const otherNeedsComment = otherTodo.callsToComment.includes(call.id);

    return (
      <div className="playlist-call-todo">
        {!prepShouldComment && !prepShouldScore ? (
          <div className="done-text">
            No action required from you.
            <div className="background-check">✓</div>
            {(otherNeedsScore || otherNeedsComment) && (
              <div className="other-todos">
                {this.otherTodoText(otherNeedsScore, otherNeedsComment)}
              </div>
            )}
          </div>
        ) : (
          <ul>
            {prepShouldScore && <li className={scoreClass}>Score this call</li>}
            {prepShouldComment && <li className={commentClass}>Leave comments</li>}
          </ul>
        )}
      </div>
    );
  }
}

PlaylistCallTodo.propTypes = {
  call: PropTypes.instanceOf(CallDetails),
  todo: PropTypes.instanceOf(CoachingTodo),
  otherTodo: PropTypes.instanceOf(CoachingTodo),
  participant: PropTypes.instanceOf(CoachingParticipant),
  otherParticipant: PropTypes.instanceOf(CoachingParticipant),
};
